import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleText6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubbleText6"><Path d="M15.5 9.5H8.5M12.5 14.5H8.5M2.5 20.5H16.5C19.2614 20.5 21.5 18.2614 21.5 15.5V8.5C21.5 5.73858 19.2614 3.5 16.5 3.5H7.5C4.73858 3.5 2.5 5.73858 2.5 8.5V20.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBubbleText6;
